exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nocardpage{width:100%;height:100%}.nocardpage .content{height:2.4rem;text-align:center;background-color:#fff;color:#3d97d1;font-family:MicrosoftYaHei;font-size:.26rem}.nocardpage .imgbox{position:relative;height:1.5rem;display:block}.nocardpage .nocardpic{top:50%;width:.81rem;height:.81rem;margin-bottom:.28rem;position:absolute;left:50%;margin-left:-.4rem;margin-top:-.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64b7a03e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/waitinginfo/nocard.vue
// module id = XbOD
// module chunks = 1